import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCo2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 490 490",
	style: { enableBackground: "new 0 0 490 490" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M470,360.75h-79.6c-8.1,0-15.4-4.8-18.5-12.3c-3.1-7.4-1.5-16,4.2-21.8l59.2-60.2c1.1-1.7,2.2-4.2,2.2-7.4 c0-7.5-6.1-13.6-13.6-13.6s-13.6,6.1-13.6,13.6c0,11.1-9,20-20,20c-11.1,0-20-9-20-20c0-29.6,24.1-53.6,53.6-53.6 s53.6,24.1,53.6,53.6c0,11.8-3.8,23.1-10.9,32.5c-0.5,0.7-1.1,1.3-1.7,1.9l-26.8,27.2H470c11.1,0,20,9,20,20 C490,351.85,481.1,360.75,470,360.75z",
			stroke: "white"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M271.8,321.75c-53.1,0-96.2-43.2-96.2-96.2c0-53.1,43.2-96.2,96.2-96.2c53.1,0,96.2,43.2,96.2,96.2 S324.9,321.75,271.8,321.75z M271.8,169.35c-31,0-56.2,25.2-56.2,56.2s25.2,56.2,56.2,56.2s56.2-25.2,56.2-56.2 C328,194.55,302.8,169.35,271.8,169.35z",
			stroke: "white"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M94.3,317.85c-52,0-94.3-42.3-94.3-94.3s42.3-94.3,94.3-94.3c29.8,0,58.1,14.3,75.8,38.3c6.6,8.9,4.7,21.4-4.2,28 s-21.4,4.7-28-4.2c-10.4-14-26.3-22-43.6-22c-29.9,0-54.2,24.3-54.2,54.2s24.3,54.2,54.2,54.2c15.3,0,29.5-6.2,39.9-17.5 c7.5-8.1,20.2-8.7,28.3-1.2c8.1,7.5,8.7,20.2,1.2,28.3C145.8,306.75,120.6,317.85,94.3,317.85z",
			stroke: "white"
		}) })
	] }) })]
});
const ForwardRef = forwardRef(SvgCo2);
export default ForwardRef;
